import React from "react";
import * as PropTypes from "prop-types";
import { Empty } from "antd";

const UIEmptyState = ({icon, title, description, action, emptyProps}) => {
	if( !title && !description )
	{
		return <Empty {...emptyProps} />;
	}

	return (
		<div className="empty-state">
			<div className="empty-state-icon">
				{icon}
				{action && <span className="empty-state-icon-badge"><i className="fal fa-plus" /></span>}
			</div>
			{title && <p className="empty-state-title">{title}</p>}
			{description && <p className="empty-state-description">{description}</p>}
			{action && <div className="empty-state-action">{action}</div>}
		</div>
	);
};

UIEmptyState.propTypes = {
	icon       : PropTypes.node,
	title      : PropTypes.string,
	description: PropTypes.string,
	action     : PropTypes.node,
	emptyProps : PropTypes.object,
};

UIEmptyState.defaultProps = {
	icon       : <i className="fal fa-inbox" />,
	title      : "",
	description: "",
	action     : null,
	emptyProps : {},
};

export default UIEmptyState;
